import React from 'react';

import NotifierBanner from 'flow/components/custom-components/NotifierBanner';
import useAppContext from 'flow/hooks/useAppContext';

const GeoOutsideFenceBanner = () => {
    const { i18next } = useAppContext();

    return (
        <NotifierBanner
            message={i18next.t('calling.outside_permitted_region')}
            theme={'warning'}
        />
    );
};

export default GeoOutsideFenceBanner;
